import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const options = { role: ROLE.SUPER_ADMIN };
const path = "/admin/notification";

export const createAdminNotification = async (values) => {
  return await axiosInstance(options).post(
    `${path}/create-admin-notification`,
    values
  );
};

/** GET: query params must be in `params` — FormData as 2nd arg to .get() is ignored by axios */
export const adminNotificationList = async ({
  page,
  per_page,
  sort,
  global_search,
}) => {
  return await axiosInstance(options).get(
    `${path}/admin-notification-list`,
    {
      params: {
        page,
        per_page,
        // sort,
        // global_search,
      },
    }
  );
};

export const adminNotificationDetails = async (id) => {
  return await axiosInstance(options).get(`${path}/view-notification`, {
    params: { id },
  });
};

export const updateAdminNotification = async (values) => {
  return await axiosInstance(options).post(`${path}/update-notification`, values);
};

export const broadcastAdminNotification = async (values) => {
  return await axiosInstance(options).post(
    `${path}/broadcast-notification`,
    values
  );
};

